import React, { useEffect } from "react";
import { connect } from "react-redux";
import ScrollIntoView from "../../../../shared/scroll-into-view/scroll-into-view";
import Loader from "./../../../../shared/loader";
import {
  fetchSetDressingOverview,
  aliasSetDressing,
  unaliasSetDressing
} from "./ducks/actions";
import { deleteMultipleSetDressings } from "./ducks/actions";
import Overview from "./overview";

const OverviewContainer = (props) => {
  const filmId = props.match.params.filmId;
  const {
    fetchSetDressingOverview,
    overview,
    loading,
    errors,
    warnings,
    aliasSetDressing,
    unaliasSetDressing,
    readOnly,
    onboardingSteps,
    processingSetDressingIds,
    deleteMultipleSetDressings
  } = props;

  useEffect(() => {
    fetchSetDressingOverview(filmId);
  }, [filmId, fetchSetDressingOverview]);

  function renderOverview(overview) {
    const totalQuantity = overview.setDressings?.reduce(
      (acc, c) => acc + (c.quantity || 0),
      0
    );

    const totalQuantityAcquired = overview.setDressings?.reduce(
      (acc, c) => acc + (c.quantityAcquired || 0),
      0
    );

    const setDressingsAcquiredPercentage =
      !totalQuantity
        ? 0
        : (totalQuantityAcquired / totalQuantity) * 100;

    return (
      <ScrollIntoView
        className="blade-content wider"
        path="/films/:filmId/set-dressings/overview"
        loading={loading}>
        <h2 className="menu-label">Overview</h2>
        <Overview
          overview={overview}
          filmId={filmId}
          errors={errors}
          warnings={warnings}
          aliasSetDressing={aliasSetDressing}
          unaliasSetDressing={unaliasSetDressing}
          readOnly={readOnly}
          setDressingsAcquiredPercentage={setDressingsAcquiredPercentage}
          onboardingSteps={onboardingSteps}
          processingSetDressingIds={processingSetDressingIds}
          deleteMultipleSetDressings={deleteMultipleSetDressings}
        ></Overview>
      </ScrollIntoView>
    );
  }

  return (
    <>
      {(loading || !overview) && <Loader />}
      {!loading && overview && renderOverview(overview)}
    </>
  );
};

function mapStateToProps(state) {
  const { errors, warnings, overview, loading, readOnly, onboardingSteps, processingSetDressingIds } =
    state.setDressingsOverviewState;
  return {
    errors,
    warnings,
    overview,
    loading,
    readOnly,
    onboardingSteps,
    processingSetDressingIds
  };
}

export default connect(mapStateToProps, {
  fetchSetDressingOverview,
  aliasSetDressing,
  unaliasSetDressing,
  deleteMultipleSetDressings
})(OverviewContainer);
